module.exports = __webpack_public_path__ + "media/images/vp/samples/09-2ad8b204820ea12f257aa805aa679415.png";